module.exports = {"name":"tacoHearts","meta":{"description":"SHIPPED - Emoji Reactions on card back (limited set)"},"audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"v1","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/tacoHearts.json
// module id = V3Ia
// module chunks = 13